import {
  STORE_RELATIONS_REASSIGN_MODAL_CURRENT_USER_LABELS,
  STORE_RELATIONS_REASSIGN_MODAL_DESCRIPTIONS
} from '../constants/storeConstants'
import {
  buildStoreRelationSalesmanOption,
  mergeUniqueStoreRelationSalesmanOptions
} from '../utils/storeRelationDisplayUtils'
import { hasStoreRelationPrincipalConflict } from './storeRelationStatusUtils'

const getPrincipalCandidates = (model) => {
  return Array.isArray(model?.principal_candidates) ? model.principal_candidates : []
}

export const buildStoreRelationStatusPayload = (model) => {
  return {
    store_salesman_relation_id: model?.client_principal?.id || null,
    client_configuration_id: model?.client_configuration?.id || null,
    supplier_id: model?.client_configuration?.supplier_id || null,
    buyer_id: model?.client_configuration?.buyer_id || null,
    buyer_external_id: model?.client_configuration?.buyer_external_id || null,
    store_reference: model?.client_configuration?.store_reference || null,
    client_id: model?.client?.id || null,
    client_db_ref: model?.client?.db_ref || null
  }
}

export const buildStoreRelationConflictCandidateOptions = (model) => {
  return getPrincipalCandidates(model)
    .map((relation, index) => {
      return buildStoreRelationSalesmanOption(
        relation?.salesman,
        relation?.id || `principal-candidate-${index}`
      )
    })
    .filter((option) => option.id || option.db_ref || option.name)
}

export const buildStoreRelationCurrentReassignUser = (model) => {
  if (hasStoreRelationPrincipalConflict(model)) {
    const principalLabels = buildStoreRelationConflictCandidateOptions(model)
      .map((option) => option.label)
      .filter(Boolean)

    return {
      id: 'principal-conflict',
      db_ref: '',
      name: '',
      label: principalLabels.length
        ? principalLabels.join(' / ')
        : STORE_RELATIONS_REASSIGN_MODAL_CURRENT_USER_LABELS.CONFLICT
    }
  }

  return {
    id: 'unassigned-principal',
    db_ref: '',
    name: STORE_RELATIONS_REASSIGN_MODAL_CURRENT_USER_LABELS.UNASSIGNED_NAME,
    label: STORE_RELATIONS_REASSIGN_MODAL_CURRENT_USER_LABELS.UNASSIGNED
  }
}

export const buildStoreRelationReassignUserOptions = (model, searchedOptions = []) => {
  return mergeUniqueStoreRelationSalesmanOptions(
    buildStoreRelationConflictCandidateOptions(model),
    Array.isArray(searchedOptions) ? searchedOptions : []
  )
}

export const getStoreRelationReassignDescription = (model) => {
  return hasStoreRelationPrincipalConflict(model)
    ? STORE_RELATIONS_REASSIGN_MODAL_DESCRIPTIONS.CONFLICT
    : STORE_RELATIONS_REASSIGN_MODAL_DESCRIPTIONS.UNASSIGNED
}

export const buildPrincipalResolutionContext = (model, nextUser) => {
  const hasConflict = hasStoreRelationPrincipalConflict(model)
  const principalCandidates = getPrincipalCandidates(model)
  const candidateRelationIds = principalCandidates
    .map((relation) => relation?.id)
    .filter(Boolean)
  const matchedCandidate = principalCandidates.find((relation) => (
    (
      nextUser?.db_ref &&
      relation?.salesman?.db_ref === nextUser.db_ref
    ) || (
      nextUser?.id &&
      relation?.salesman?.id === nextUser.id
    )
  )) || null

  return {
    action: hasConflict
      ? 'resolve_principal_conflict'
      : 'create_principal_relation',
    mode: hasConflict
      ? (matchedCandidate ? 'keep_existing_candidate' : 'replace_conflicting_candidates')
      : 'create_new_principal_relation',
    current_principal_state: hasConflict ? 'conflict' : 'unassigned',
    selected_principal_salesman_id: nextUser?.id || null,
    selected_principal_salesman_db_ref: nextUser?.db_ref || '',
    candidate_store_salesman_relation_ids: candidateRelationIds,
    kept_store_salesman_relation_id: matchedCandidate?.id || null,
    store_salesman_relation_ids_to_remove: matchedCandidate
      ? candidateRelationIds.filter((relationId) => relationId !== matchedCandidate.id)
      : candidateRelationIds,
    create_new_relation: !matchedCandidate,
    client_configuration_id: model?.client_configuration?.id || null
  }
}
